export default "__VITE_ASSET__d425b069__"